// services/userService.js
import config from '../config';

/**
 * Fetches current user profile from /me endpoint
 *
 * @param {string} token - Authentication token
 * @returns {Promise<Object>} - User profile data
 */
export const getUserProfile = async (token) => {
  try {
    const response = await fetch(`${config.API_URL}/me/`, {
      headers: {
        "Authorization": `Token ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch user profile: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};